import React from "react";
import Highcharts from "highcharts";
import {
  HighchartsProvider,
  HighchartsChart,
  Chart,
  XAxis,
  YAxis,
  Legend,
  LineSeries,
  Series,
  Tooltip
} from "react-jsx-highcharts";

const HighChartLineChart = props => {
  var lines = [];
  const { data, startpoint, triggerAnimation } = props;

  if (data[0] || data[1]) {
    for (var key in data) {
      if (data.hasOwnProperty(key) && data[key] !== null) {
        {
          let color = key == 0 ? "#1E00BE" : "#00A362";
          let currentpopulation = data[key].values.slice(-1).pop();

          let dotted = key == 0 ? "Solid" : "Solid";

          let line = [
            [...data[key].values],
            color,
            data[key].name,
            currentpopulation,
            dotted
          ];
          lines.push(line);
        }
      }
    }
  }

  Highcharts.setOptions({
    lang: {
      numericSymbols: [null]
    },
    chart: {
      height: "500px",
      plotShadow: false,
      type: "line",
      backgroundColor: "transparent",
    },
    legend: {
      align: "left",
      title: {
        text: "Förklaring",
        style: {
          fontFamily: "Inter",
          color: "#0F0865",
          lineHeight: "20px",
          letterSpacing: "0.1px",
          fontSize: "14px",
          fontWeight: "700"
        }
      },
    },
    xAxis: {
      lineColor: "#0F0865",
      visible: true,
      lineWidth: 1,
      labels: {
        style: {
          color: "#0F0865",
          fontFamily: "Inter",
          fontSize: "14px"
        }
      },
      type: "year",
      tickWidth: 1,
      startOnTick: false,
      endOnTick: true,
      showFirstLabel: true,
      showLastLabel: true
    },
    yAxis: {
      visible: true,
      min: 0,
      lineColor: "#0F0865",
      lineWidth: 1,
      tickWidth: 1,
      labels: {
        style: {
          color: "#0F0865",
          fontFamily: "Inter",
          fontSize: "14px"
        }
      },
      showFirstLabel: true,
      showLastLabel: true
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 4,
          states: {
            hover: {
              enabled: true
            }
          }
        }
      }
    }
  });
  return (
    <HighchartsProvider Highcharts={Highcharts}>
      <HighchartsChart>
        <Chart />
        <XAxis>
          {lines.map((linedata, index) => {
            if(triggerAnimation){
              return (
                <Series
                  key={index}
                  name={linedata[2]}
                  data={linedata[0]}
                  color={linedata[1]}
                  dashStyle={linedata[4]}
                  pointStart={startpoint}
                >
                  <Tooltip />
                </Series>
              );

            } else {
            return (
              null
            )}
          })}
        </XAxis>
        <YAxis>
          <Legend/>
        </YAxis>
      </HighchartsChart>
    </HighchartsProvider>
  );
};

export default HighChartLineChart;
